import React from 'react'
import TitleName from 'src/assets/img/house/modal_title_name.png'
import TitleRank from 'src/assets/img/house/modal_title_rank.png'
import TitleIcon from 'src/assets/img/house/modal_title_icon.png'
import TitleMessage from 'src/assets/img/house/modal_title_message.png'
import PropTypes from 'prop-types'

const LabelModalHouse = ({ type, htmlFor }) => {
  const imageMap = {
    name: TitleName,
    rank: TitleRank,
    icon: TitleIcon,
    message: TitleMessage
  }

  const imageSrc = imageMap[type] || TitleName

  return (
    <label htmlFor={htmlFor} className="w-20 xs:w-28 h-auto -rotate-3">
      <img className="w-full h-full" src={imageSrc} alt={htmlFor || 'label user info'} />
    </label>
  )
}

LabelModalHouse.propTypes = {
  type: PropTypes.oneOf(['name', 'rank', 'icon', 'message']),
  htmlFor: PropTypes.string
}

export default LabelModalHouse
